import data from './data'
import methods from './methods'
import mounted from './mounted'
import props from './props'

export default {
  data,
  methods,
  mounted,
  props
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/components/statistics/resources/index.js